/**
 * Today, `YYYY-MM-DD`, in `timezone` when it is known (the workspace's), else
 * on the reader's own calendar. Forms use it to offer only days the API will
 * take; the API checks again against the workspace's own day.
 */
export const localToday = (timezone?: string, now = new Date()): string => {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now)
    const part = (type: string) => parts.find((p) => p.type === type)?.value ?? ''
    return `${part('year')}-${part('month')}-${part('day')}`
  } catch {
    return localToday(undefined, now)
  }
}
